import React, { memo, forwardRef, useCallback } from "react";
import "./InputRadioField.css";

const InputRadioField = forwardRef(({ id, label, setValue, ...rest }, ref) => {

    return (
        <div className="input-radio-field" data-testid="input-radio-field">
            <label htmlFor={id}>
                <input
                    type="radio"
                    className="input-radio-field__option radio"
                    {...rest}
                    ref={ref}
                    data-testid="input-radio"
                />
                {label}
            </label>
        </div>
    );
});

export default memo(InputRadioField);
